import { render } from "./AreaText.vue?vue&type=template&id=3c16ccc2&scoped=true&ts=true"
import script from "./AreaText.vue?vue&type=script&lang=ts"
export * from "./AreaText.vue?vue&type=script&lang=ts"

import "./AreaText.vue?vue&type=style&index=0&id=3c16ccc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c16ccc2"]])

export default __exports__